import React from "react";
import "./NotFound.scss";
import NotFoundComponent from "./NotFoundComponent";

const NotFound = (props: any) => {

  return (
    <div
      className="not-found-wrapper"
      style={{ height:  '100vh' }}
    >
      <NotFoundComponent user={props.user} message={props.message} subMessage={props.subMessage} showSubMessage={true} />
    </div>
  );
};

export default NotFound;
